


















































































































import { Component, Vue } from "vue-property-decorator";
import InspectList from "./InspectList.vue";
import { UserService } from "@/service/UserService";
@Component({
  components: {
  }
})
export default class QuickSeibiList extends InspectList {
  getSeibi() {
    if (this.hasData) {
      this.setListSeibi();
      this.setIndexTooltip();
    } else if (!this.isLoading) {
      const userService = new UserService();
      userService.getAllDataQM();
    }
  }

}
